<template>
  <v-dialog
    v-model="dialogAddAddressVisible"
    fullscreen
    persistent
    hide-overlay
    transition="slide-x-reverse-transition"
  >
    <v-card style="position: relative">
      <button
        @click="closeDialog"
        style="
          position: absolute;
          width: 26px;
          height: 26px;
          top: 25px;
          left: 20px;
        "
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
          <path
            style="fill: #232326"
            d="M24 12.001H2.914l5.294-5.295-.707-.707L1 12.501l6.5 6.5.707-.707-5.293-5.293H24v-1z"
            data-name="Left"
          />
        </svg>
      </button>
      <h2 v-if="editAddress === false" class="text-center pt-5 pb-2">
        {{ $t("add") }} {{ $t("addressSendReward") }}
      </h2>
      <h2 v-if="editAddress === true" class="text-center pt-5 pb-2">
        {{ $t("edit") }} {{ $t("addressSendReward") }}
      </h2>
      <v-divider style="border-color: rgb(0 0 0 / 20%)"></v-divider>

      <section style="overflow-y: auto; max-height: 90vh">
        <v-form
          ref="form"
          class="d-flex flex-column align-center mt-8 px-4"
          v-model="valid"
          lazy-validation
        >
          <v-row style="width: 100%; max-width: 600px">
            <h4 class="pl-4 blue-grey--text text--darken-2">
              {{ $t("locationName") }}
            </h4>
            <v-col cols="12" class="" style="margin-top: -5px">
              <v-text-field
                :color="site.color"
                v-model="residence.name_address"
                :rules="normalRules"
                class=""
                required
                dense
                outlined
                background-color="white"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Place name, fullname, phone -->
          <v-row style="width: 100%; margin-top: -15px; max-width: 600px">
            <v-col cols="5" class="" style="margin-top: -5px">
              <h4 class="pl-1 blue-grey--text text--darken-2">
                {{ $t("name") }}
              </h4>
              <v-text-field
                :color="site.color"
                v-model="residence.name"
                :rules="normalRules"
                class="mt-1"
                required
                dense
                outlined
                background-color="white"
              ></v-text-field>
            </v-col>
            <v-col cols="7" class="" style="margin-top: -5px">
              <h4 class="pl-1 blue-grey--text text--darken-2">
                {{ $t("surname") }}
              </h4>
              <v-text-field
                :color="site.color"
                v-model="residence.surname"
                :rules="normalRules"
                class="mt-1"
                required
                dense
                outlined
                background-color="white"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row style="width: 100%; margin-top: -10px; max-width: 600px">
            <h4 class="pl-4 blue-grey--text text--darken-2">
              {{ $t("phone") }}
            </h4>
            <v-col cols="12" class="" style="margin-top: -5px">
              <v-text-field
                :color="site.color"
                v-model="residence.mobile"
                :rules="phoneRules"
                class=""
                required
                dense
                outlined
                background-color="white"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>

        <div class="d-flex justify-center px-5 mt-3">
          <v-divider
            style="border-color: rgb(0 0 0 / 20%); max-width: 600px"
          ></v-divider>
        </div>

        <!-- Address details -->
        <section class="d-flex flex-column align-center" style="width: 100%">
          <v-form
            ref="editForm"
            class="d-flex flex-column align-center mt-8 px-4"
            style="max-width: 600px; width: 100%"
            lazy-validation
          >
            <h3 class="text-start pl-3" style="width: 100%">
              {{ $t("addressDetail") }}
            </h3>

            <!-- comporessed address -->
            <div
              class="my-3 pa-3"
              v-if="residence.address && residence.address.length > 0"
              style="
                width: 95%;
                border-radius: 10px;
                background-color: oklch(0.968 0.007 247.896);
              "
            >
              {{ residence.address }}
            </div>
            <div
              class="my-3 pa-3"
              v-else
              style="
                width: 95%;
                border-radius: 10px;
                background-color: oklch(0.968 0.007 247.896);
              "
            >
              -
            </div>
            <div
              style="width: 95%"
              :style="{ color: site.color }"
              class="font-weight-bold"
            >
              <div
                class="d-flex"
                style="cursor: pointer"
                @click="openEditAddressDetails = !openEditAddressDetails"
              >
                <div
                  style="width: 20px; height: 20px"
                  class="mr-2"
                  :style="{ fill: site.color }"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                      d="M8.661,19.113,3,21l1.887-5.661ZM20.386,7.388a2.1,2.1,0,0,0,0-2.965l-.809-.809a2.1,2.1,0,0,0-2.965,0L6.571,13.655l3.774,3.774Z"
                    />
                  </svg>
                </div>
                {{ $t("edit") }} {{ $t("addressDetail") }}
              </div>
            </div>

            <div
              v-if="openEditAddressDetails === true"
              class="mt-5 d-flex flex-column justify-center"
              style="width: 95%; border-radius: 10px"
              :style="{ border: '1px solid ' + site.color }"
            >
              <v-row class="px-10 py-5" style="width: 105%">
                <h4 class="mt-4 blue-grey--text text--darken-2">
                  {{ $t("address") }}
                </h4>
                <v-col cols="12" class="pa-0 mt-2">
                  <v-text-field
                    v-model="addressUser.address"
                    :rules="normalRules"
                    class=""
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                  <p
                    v-if="!addressUser.address"
                    class="text-caption red--text my-0 mt-1 ml-0"
                  >
                    {{ $t("required") }}
                  </p>
                </v-col>
                <h4 class="mt-4 blue-grey--text text--darken-2">
                  {{ $t("sub_district") }}
                </h4>
                <v-col cols="12" class="pa-0 pt-2">
                  <addressinput-subdistrict
                    v-model="addressUser.sub_district"
                    :rules="normalRules"
                    label=""
                    class=""
                    style="border-radius: 8px"
                  />
                  <p
                    v-if="!addressUser.sub_district"
                    class="text-caption red--text my-0 mt-1 ml-0"
                  >
                    {{ $t("required") }}
                  </p>
                </v-col>
                <h4 class="mt-4 blue-grey--text text--darken-2">
                  {{ $t("district") }}
                </h4>
                <v-col cols="12" class="pa-0 pt-2">
                  <addressinput-district
                    v-model="addressUser.district"
                    :rules="normalRules"
                    label=""
                  />
                  <p
                    v-if="!addressUser.district"
                    class="text-caption red--text my-0 mt-1 ml-0"
                  >
                    {{ $t("required") }}
                  </p>
                </v-col>
                <h4 class="mt-4 blue-grey--text text--darken-2">
                  {{ $t("province") }}
                </h4>
                <v-col cols="12" class="pa-0 pt-2">
                  <addressinput-province
                    v-model="addressUser.province"
                    :rules="normalRules"
                    label=""
                  />
                  <p
                    v-if="!addressUser.province"
                    class="text-caption red--text my-0 mt-1 ml-0"
                  >
                    {{ $t("required") }}
                  </p>
                </v-col>
                <h4 class="mt-4 blue-grey--text text--darken-2">
                  {{ $t("zipcode") }}
                </h4>
                <v-col cols="12" class="pa-0 pt-2">
                  <addressinput-zipcode
                    v-model="addressUser.zipcode"
                    :rules="normalRules"
                    label=""
                  />
                  <p
                    v-if="!addressUser.zipcode"
                    class="text-caption red--text my-0 mt-1 ml-0"
                  >
                    {{ $t("required") }}
                  </p>
                </v-col>
              </v-row>
              <div class="d-flex mb-5 justify-end pr-5 mt-2">
                <v-btn
                  class="mr-2 rounded-lg font-weight-bold"
                  :color="site.color"
                  @click="saveDialogEditAddress()"
                  style="color: white"
                  >{{ $t("confirm") }}</v-btn
                >
                <v-btn
                  outlined
                  class="mr-2 rounded-lg font-weight-bold"
                  :color="site.color"
                  style=""
                  @click="openEditAddressDetails = false"
                  >{{ $t("cancel") }}</v-btn
                >
              </div>
            </div>
          </v-form>
        </section>

        <section
          class="mt-10 px-5 pl-6 d-flex justify-center"
          style="margin-bottom: 50px"
        >
          <v-col
            cols="12"
            class="pa-0 d-flex justify-start"
            style="max-width: 600px"
          >
            <v-checkbox
              v-model="residence.is_default"
              :color="site.color"
              class="mt-0"
              :label="`${$t('selectDefautAddress')}`"
            >
            </v-checkbox>
          </v-col>
        </section>

        <div style="height: 100px"></div>
      </section>

      <!-- Footer -->
      <section
        class="d-flex flex-column justify-center align-center py-5"
        style="
          background-color: white;
          position: absolute;
          bottom: 0px;
          width: 100%;
          box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);
          z-index: 20;
        "
      >
        <v-btn
          @click="saveAddress"
          :color="site.color"
          class="rounded-lg font-weight-bold"
          style="width: 75%; color: white; height: 40px; max-width: 600px"
        >
          {{ $t("confirm") }}
        </v-btn>
      </section>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "DialogAddAddress",
  props: ["dialogAddAddressVisible"],
  data() {
    return {
      openEditAddressDetails: false,
      valid: true,

      addressUser: {
        address: "",
        sub_district: "",
        district: "",
        province: "",
        zipcode: "",
      },
      residence: {
        name: "",
        surname: "",
        mobile: "",
        address: "",
        is_default: false,
        id: null,
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    saveAddress() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.residence.address) {
        this.openEditAddressDetails = true;
        return;
      }
      this.$emit("updateResidence", this.residence, this.editAddress);
      this.$emit("close");
    },
    handleAddressChange() {
      if (this.editAddress === false) {
        this.residence.name_address = "";
        this.residence.name = this.customer.name;
        this.residence.surname = this.customer.surname;
        this.residence.mobile = this.mobile;
        this.residence.is_default = false;
        this.residence.address = "";
      } else {
        this.residence.name_address = this.residenceEmployee.name_address;
        this.residence.name = this.residenceEmployee.name;
        this.residence.surname = this.residenceEmployee.surname;
        this.residence.mobile = this.residenceEmployee.mobile;
        this.residence.address = this.residenceEmployee.address;
        this.residence.id = this.residenceEmployee.id;
        this.residence.is_default = this.residenceEmployee.is_default;
      }
    },
    resetAddressUser() {
      this.addressUser = {
        address: "",
        sub_district: "",
        district: "",
        province: "",
        zipcode: "",
      };
    },
    saveDialogEditAddress() {
      if (!this.$refs.editForm.validate()) {
        return;
      }
      if (Object.values(this.addressUser).includes("")) {
        return;
      }
      if (this.addressUser.province == "กรุงเทพมหานคร") {
        this.addressUser.district = `เขต ${this.addressUser.district}`;
        this.addressUser.sub_district = `แขวง ${this.addressUser.sub_district}`;
      } else {
        this.addressUser.district = `อำเภอ ${this.addressUser.district}`;
        this.addressUser.sub_district = `ตำบล ${this.addressUser.sub_district}`;
      }
      this.residence.address = Object.values(this.addressUser).join(" ");

      this.openEditAddressDetails = false;
    },
  },

  created() {
    this.handleAddressChange();
  },
  computed: {
    ...mapState("address", ["residenceEmployee", "editAddress"]),
    ...mapState("defaultSystem", ["site", "customer"]),
    ...mapState("login", ["mobile"]),

    normalRules() {
      return [(v) => !!v || this.$t("validation.required")];
    },
    phoneRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) =>
          /^(08|06|09)\d{8}$/.test(v) || this.$t("validation.phoneInvalid"),
      ];
    },
  },
  watch: {
    editAddress() {
      this.handleAddressChange();
      this.resetAddressUser();
      this.openEditAddressDetails = this.editAddress ? false : true;
    },

    residenceEmployee() {
      this.handleAddressChange();
      this.resetAddressUser();
      this.openEditAddressDetails = this.editAddress ? false : true;
    },
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #d5d5d5;
  border-radius: 0px;
}
</style>